<template>
    <div class="page-address page-address-order">
        <div class="container">
            <div class="address-box">
                <div class="btn-box">
                    <app-button size="md" color="gray-solid" class="summary-btn"
                                @click.native="editAddress('')">
                        新增收货地址
                    </app-button>
                </div>


                <div class="address-list" :class="{'fold':fold}">
                    <AddressItem :item="item" v-for="(item,index) in addressList" :key="index"
                                 :clickId="clickId"
                                 @editAddress="editAddress"
                                 @selectItem="selectItem"></AddressItem>

                    <div class="btn" v-if="addressList && addressList.length>3">
                        <div class="more" v-if="fold" @click="fold=false">查看更多
                            <font-awesome-icon icon="angle-double-down"></font-awesome-icon>
                        </div>
                        <div class="more" v-if="!fold" @click="fold=true">收起
                            <font-awesome-icon icon="angle-double-up"></font-awesome-icon>
                        </div>
                    </div>

                    <p v-if="addressList.length==0" style="margin:20px 0;">暂无相关地址</p>
                </div>
            </div>

        </div>

        <AddAddress :visible="visible" :selectId="selectId"
                    @closeDialog="visible=false"></AddAddress>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import AddAddress from './Add'
    import AddressItem from './Item'

    export default {
        data() {
            return {
                clickId: '',
                visible: false,
                selectId: '',
                fold: true,
            };
        },
        props: [],
        components: {AddAddress, AddressItem},
        computed: mapState({
            addressList: state => state.address.addressList,
            mapSelectId: state => state.address.selectId,
        }),
        created() {
            this.getAddressList();
        },
        activated() {
        },
        mounted() {
        },
        watch: {
            addressList: {
                handler: function (curVal, oldVal) {
                    if (oldVal.length == 0) {
                        this.selectItem(this.mapSelectId);
                    }
                }, deep: true, //immediate: true,
            },
        },
        methods: {
            getAddressList() {
                this.$store.dispatch('address/getAddressList').then(() => {
                    this.selectItem(this.mapSelectId);
                });
            },
            editAddress(id) {
                this.selectId = id;
                this.visible = true;
            },
            selectItem(id) {
                this.clickId = id;
                this.$emit('selectAddress', id);
            },
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    @import "../../style/page-common";

    .page-address {
        .container {
            position: relative;
        }
    }

    .address-box {
        position: relative;

        .btn-box {
            position: absolute;
            right: 0;
            top: -40px;
        }

        .address-list {
            padding-top: 20px;
            margin-bottom: 50px;
        }

        .btn {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            padding-top: 23px;
            margin-bottom: 60px;

            .more {
                cursor: pointer;
            }
        }

        .fold {
            .address-item:nth-child(n+4) {
                display: none;
            }
        }
    }
</style>

<style lang="scss" type="text/scss">
    .page-address-order {
        .address-item {
            .address-text {
                padding: 12px 16px;

                border: 1px solid #F5F5F5;
                border: 1px solid gainsboro;
                cursor: pointer;

                &.active {
                    border: 1px solid #C19A77FF;

                    &:after {
                        content: '';
                        width: 20px;
                        height: 20px;
                        display: block;
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        background: url("../../assets/images/order/active.png") center no-repeat;
                    }
                }
            }
        }
    }
</style>